import 'zone.js';
// Ensure a `global` reference exists in browser/test environments that expect Node's `global`.
if (typeof (globalThis as any).global === 'undefined') {
	(globalThis as any).global = globalThis;
}